import { type ReactElement } from 'react';
import { type CustomResponseProps } from '../../chat-responses/types.js';

type Props = CustomResponseProps<'rep-two-minute-summary'>;

export function RepTwoMinuteSummary(_: Props): ReactElement {
  return <div />;
}
